import { AuthHttp } from 'app/infrastructure/common';
import { Injectable } from '@angular/core';
import { AppSettings } from 'app/infrastructure/settings';
import { Response, RequestOptions, URLSearchParams } from '@angular/http';

@Injectable()
export class MenuService {
    constructor(private http: AuthHttp) { }

    getMenu(moduleId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('moduleId', moduleId);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Menu/GetMenu', options)
            .map((response: Response) => response.json());
    }

	getDefaultWelcomeScreen(moduleId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('moduleId', moduleId);
        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Menu/GetDefaultWelcomeScreen', options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/config/menu.service.ts